<template>
  <div>
    <vs-button @click="popupActivo=true" color="primary" type="filled">Assign Doctor</vs-button>
    <vs-popup  title="Lorem ipsum dolor sit amet" :active.sync="popupActivo">
      <!-- center items in div -->
      <div class="w-full min flex flex-wrap justify-center items-center p-4">
        <!-- with same as div above -->
        <vs-select  v-model="emrDoctors" label="Assign Doctor" placeholder="Select Doctor" class="w-full" multiple autocomplete>
          <vs-select-item
            v-for="item in emrDoctorList"
            :key="item.id"
            :value="item.id"
            :text="`${item.firstName} ${item.lastName} ('${item.email}')`"
          />
        </vs-select>
        <div class="w-full flex justify-end mt-4">
          <vs-button color="primary" type="border" @click="resetFields">Cancel</vs-button>
          <span class="assignDoctor ml-4">
            <vs-button color="primary" type="filled" @click="assignDoctor">Assign</vs-button>
          </span>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'assignEmrDoctor',
  data() {
    return {
      popupActivo: false,
      emrDoctorList: [],
      emrDoctors: [],
    };
  },
  methods: {
    ...mapActions('doctor', ['fetchUnassignedEMRDoctors']),
    assignDoctor() {
      try {
        this.$vs.loading();
        this.$store.dispatch('doctor/assignEmrDoctor', {
          clinicId: this.$route.params.clinicId,
          userId: this.emrDoctors,
        });
        setTimeout( ()=> {
          this.resetFields();
          this.$vs.loading.close();
        }, 500);
        this.$vs.notify({
          title: 'Success',
          text: 'Assigned doctors successfully.',
          color: 'success',
        });
      } catch (error) {
        console.log(error);
        setTimeout( ()=> {
          this.$vs.loading.close();
        }, 500);
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to assign doctors. Try again.',
          color: 'danger',
        });
      }
    },
    async getUnassignedEMRDoctors() {
      const response = await this.fetchUnassignedEMRDoctors(this.$route.params.clinicId);
      this.emrDoctorList = response.data.data;
    },
    resetFields() {
      this.$emit('getDoctorsList');
      this.emrDoctors = [];
      this.popupActivo = false;
    },
  },
  created() {
    this.getUnassignedEMRDoctors();
  },
};
</script>

<style>
  .assignDoctor .vs-button{
    border: 1px solid rgba(var(--vs-primary),1);
    padding: .679rem 2rem !important;
  }
</style>
